import styled from '../../../styled';

const STEP_CONTENT_MAX_WIDTH = 740;

export const StepContentContainer = styled.div`
  max-width: ${STEP_CONTENT_MAX_WIDTH}px;
`;
